module.exports = __webpack_public_path__ + "img/skredhendelser.6b1c5c6b.jpg";